module.exports = __webpack_public_path__ + "img/green-key-fr.458d6068.png";